"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.priceFormat = priceFormat;
exports.priceFormatForDecimals = priceFormatForDecimals;
function priceFormat(val) {
    let s = '';
    if (typeof val === 'number') {
        s = val.toFixed(0);
    }
    else {
        s = val || '';
    }
    if (s.includes(',')) {
        return s;
    }
    if (s.includes('$')) {
        return s;
    }
    const minus = s.slice(0, 1) == '-' ? '-' : '';
    if (minus) {
        s = s.slice(1);
    }
    let result = '';
    while (s) {
        const last = s.slice(-3);
        if (result) {
            result = last + ',' + result;
        }
        else {
            result = last;
        }
        s = s.slice(0, -3);
    }
    return minus + '$' + result;
}
function priceFormatForDecimals({ val, roundDecimals = false }) {
    if (val === undefined || val === null)
        return '';
    let num;
    if (typeof val === 'string') {
        num = parseFloat(val.replace(/[^0-9.-]/g, ''));
        if (isNaN(num))
            return val;
    }
    else {
        num = val;
    }
    const isNegative = num < 0;
    const absNum = Math.abs(num);
    const fixed = absNum.toFixed(2); // Always has 2 decimal places
    const [intPart, decimalPart] = fixed.split('.');
    const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const withDecimal = `${isNegative ? '-' : ''}$${formattedInt}.${decimalPart}`;
    const withoutDecimal = `${isNegative ? '-' : ''}$${formattedInt}`;
    return decimalPart === '00' || roundDecimals ? withoutDecimal : withDecimal;
}
